import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OpdScheduleManagerComponent } from '../opd-schedule-manager/opd-schedule-manager.component';
import { scheduleTypeModal } from 'app/masters/models/service-master.model';
import { LocationService } from 'app/masters/location-master/location.service';
import { takeUntil } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-schedule-type-master',
  templateUrl: './schedule-type-master.component.html',
  styleUrls: ['./schedule-type-master.component.scss']
})
export class ScheduleTypeMasterComponent implements OnInit {
  popbutton: number;
  dataSource = new MatTableDataSource<any>();
  destroyscheduleType$: Subject<boolean> = new Subject<boolean>()
  displayedColumns: string[] = ['scheduleGroup', 'scheduleType', 'scheduleTypeColorCode', 'scheduleDisplay', 'isActive'];
  searchValue: string;
  scheduleTypeData: scheduleTypeModal = {};

  constructor(public dialogRef: MatDialogRef<OpdScheduleManagerComponent>, public dialog: MatDialog, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public LocationService: LocationService) { }

  ngOnInit(): void {
    this.popbutton = 0;
    if (this.data.id != null && this.data.id != undefined) {
      this.popbutton = this.data.id;
    }
    this.dataSource.filterPredicate = this.createFilter();
    this.getscheduleData()
  }
  openscheduletypeModal() {
    document.getElementById("scheduletypeModal").style.display = 'block';
    this.getscheduleData()
  }
  closescheduletypeModal() {
    document.getElementById("scheduletypeModal").style.display = 'none';
    this.dataSource.filter = "";
    this.searchValue = ''
  }
  closedailog() {
    this.dialogRef.close();
  }
  getscheduleData() {
    this.LocationService.GetScheduleTypeMaster()
      .pipe(takeUntil(this.destroyscheduleType$))
      .subscribe(
        (item: any[]) => {
          this.dataSource.data = item
        },
        (err) => {
          console.error("API Failed", err);
        }
      );
  }
  applyscheduletypeFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  createFilter(): (data: any, filter: string) => boolean {
    return (data, filter): boolean => {
      const transformedFilter = filter.trim().toLowerCase();
      return (
        data.scheduleType?.toLowerCase().includes(transformedFilter) ||
        data.scheduleGroup?.toLowerCase().includes(transformedFilter) ||
        data.scheduleTypeColorCode?.toLowerCase().includes(transformedFilter) ||
        data.scheduleDisplay?.toLowerCase().includes(transformedFilter) ||
        (data.isActive ? "active" : "inactive").includes(transformedFilter)
      );
    };
  }
  savescheduletypeData() {
    if (!this.scheduleTypeData.pK_ScheduleTypeId) {
      const existingbillseries = this.dataSource.data.find(
        (schedule) => 
          schedule.scheduleType.toLowerCase() == this.scheduleTypeData.scheduleType?.toLowerCase() &&
          schedule.scheduleGroup.toLowerCase() == this.scheduleTypeData.scheduleGroup?.toLowerCase()
      );
  
      if (existingbillseries) {
        this.LocationService.openSnackBar('Already exists in the list', 'OK');
        this.clearForm();
        return;
      }
      const payload = {
        "InsertScheduleTypeMaster": {
          "PK_ScheduleTypeId": this.scheduleTypeData.pK_ScheduleTypeId ? this.scheduleTypeData.pK_ScheduleTypeId : 0,
          "ScheduleType": this.scheduleTypeData.scheduleType,
          "ScheduleTypeColorCode": this.scheduleTypeData.scheduleTypeColorCode ? this.scheduleTypeData.scheduleTypeColorCode: '#0d0202',
          "ScheduleGroup": this.scheduleTypeData.scheduleGroup,
          "IsActive": this.scheduleTypeData.isActive ? this.scheduleTypeData.isActive : false,
          "ScheduleDisplay": this.scheduleTypeData.scheduleDisplay,
          "IsEdit": false
        },
      };
      this.LocationService.InsertScheduleTypeMaster(payload).pipe(takeUntil(this.destroyscheduleType$)).subscribe(
        (response: any) => {
          this.LocationService.openSnackBar('Record saved successfully', 'OK');
          this.clearForm();
          this.searchValue = ''
          this.getscheduleData()
        },
        err => {
          if (err.status == 403) {
            this.LocationService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.LocationService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.LocationService.openSnackBar("API Failed", "OK");
          }
          this.searchValue = ''
        }
      );
    } else {
      const payload = {
        "InsertScheduleTypeMaster": {
          "PK_ScheduleTypeId": this.scheduleTypeData.pK_ScheduleTypeId ? this.scheduleTypeData.pK_ScheduleTypeId : 0,
          "ScheduleType": this.scheduleTypeData.scheduleType,
          "ScheduleTypeColorCode": this.scheduleTypeData.scheduleTypeColorCode ? this.scheduleTypeData.scheduleTypeColorCode: '#0d0202',
          "ScheduleGroup": this.scheduleTypeData.scheduleGroup,
          "IsActive": this.scheduleTypeData.isActive ? this.scheduleTypeData.isActive : false,
          "ScheduleDisplay": this.scheduleTypeData.scheduleDisplay,
          "IsEdit": true
        },
      };
      this.LocationService.InsertScheduleTypeMaster(payload).pipe(takeUntil(this.destroyscheduleType$)).subscribe(
        (response: any) => {
          if (response.statusCode == 1) {
            this.LocationService.openSnackBar('Record updated successfully', 'OK');
            this.clearForm();
            this.searchValue = ''
            this.getscheduleData()
          } else if (response.statusCode == 10) {
            this.LocationService.openSnackBar('Alreday exists in the list', 'OK');
            this.clearForm();
            return;
          }
        },
        err => {
          if (err.status == 403) {
            this.LocationService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.LocationService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.LocationService.openSnackBar("API Failed", "OK");
          }
          this.searchValue = ''
        }
      );
    }
  }

  clearForm() {
    this.scheduleTypeData = {
      pK_ScheduleTypeId: 0,
      scheduleType: '',
      scheduleTypeColorCode: '',
      scheduleGroup: '',
      isActive: false,
      scheduleDisplay: ''
    };
  }
  onRowDoubleClick(row) {
      this.scheduleTypeData.pK_ScheduleTypeId = row.pK_ScheduleTypeId,
      this.scheduleTypeData.scheduleType = row.scheduleType,
      this.scheduleTypeData.scheduleTypeColorCode = row.scheduleTypeColorCode,
      this.scheduleTypeData.scheduleGroup = row.scheduleGroup,
      this.scheduleTypeData.isActive = row.isActive,
      this.scheduleTypeData.scheduleDisplay = row.scheduleDisplay
      this.closescheduletypeModal()
  }
  ngOnDestroy() {
    this.destroyscheduleType$.next(true);
    this.destroyscheduleType$.unsubscribe();
    this.dataSource.data = [];
    this.displayedColumns = [];
    this.searchValue = null;
  }
}
